document.addEventListener('DOMContentLoaded', function () {
    var active = false;
    document.querySelectorAll('.block-files .collapse-init').forEach(function (i) {
        i.addEventListener('click', function (e) {
            if (i.parentNode.classList.contains('active')) {
                active = i;
                i.parentNode.classList.remove('active');
            } else {
                // scrollCollapse(i);
                active = false;
                document.querySelectorAll('.block-files .collapse-content').forEach(function (x) {
                    return x.classList.remove('active')
                });
                i.parentNode.classList.add('active');
            }
        });
    });

    // const scrollCollapse = function (elem) {
    //     let activeItem = jQuery('.block-files .collapse .active'),
    //         height = activeItem.find('.collapse-content').height(),
    //         offset = jQuery(elem).offset().top;
    //
    //     if (height && jQuery(elem).closest('.item').data('key') > activeItem.data('key')) {
    //         offset = offset - height - 15;
    //     }
    //
    //     jQuery('html, body').stop().animate({scrollTop: offset}, 400);
    // };
});